import api from './api';

export interface QuotationItem {
  item_id?: number;
  product_id?: number;
  bundle_id?: number;
  description?: string;
  quantity: number;
  unit_price: number;
  discount_amount?: number;
  line_total?: number;
  notes?: string;
  sort_order?: number;
  products?: {
    product_id: number;
    product_name: string;
    sku: string;
  };
}

export interface Quotation {
  quotation_id: number;
  quotation_number: string;
  customer_id?: number;
  customer_name?: string;
  customer_email?: string;
  customer_phone?: string;
  quotation_date: string;
  expiry_date?: string;
  subtotal: number;
  discount_amount?: number;
  discount_percent?: number;
  tax_amount?: number;
  vat_type?: string | null;
  tax_percent?: number | null;
  total_amount: number;
  status: 'draft' | 'sent' | 'accepted' | 'rejected' | 'converted';
  notes?: string;
  terms_conditions?: string;
  converted_sale_id?: number;
  created_at?: string;
  updated_at?: string;
  customers?: {
    customer_id: number;
    company_name?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
  };
  quotation_items: QuotationItem[];
  users?: {
    first_name: string;
    last_name: string;
  };
}

export interface CreateQuotationData {
  customer_id?: number;
  customer_name?: string;
  customer_email?: string;
  customer_phone?: string;
  quotation_date?: string;
  expiry_date?: string;
  items: {
    product_id?: number;
    bundle_id?: number;
    description?: string;
    quantity: number;
    unit_price: number;
    discount_amount?: number;
  }[];
  discount_amount?: number;
  discount_percent?: number;
  tax_amount?: number;
  notes?: string;
  terms_conditions?: string;
}

export interface ConvertQuotationResponse {
  quotation_id: number;
  quotation_number: string;
  customer?: {
    customer_id: number;
    company_name?: string;
    first_name?: string;
    last_name?: string;
  };
  customer_name?: string;
  customer_email?: string;
  customer_phone?: string;
  items: {
    product_id?: number;
    bundle_id?: number;
    description?: string;
    quantity: number;
    unit_price: number;
    discount_amount?: number;
  }[];
  discount_amount?: number;
  discount_percent?: number;
  subtotal: number;
  total_amount: number;
}

export const quotationService = {
  getAll: (params?: { status?: string; customer?: number; page?: number; limit?: number }) =>
    api.get('/quotations', { params }),

  getById: (id: number) => api.get(`/quotations/${id}`),

  create: (data: CreateQuotationData) => api.post('/quotations', data),

  update: (id: number, data: Partial<CreateQuotationData>) =>
    api.put(`/quotations/${id}`, data),

  delete: (id: number) => api.delete(`/quotations/${id}`),

  convertToSale: (id: number) => api.post<ConvertQuotationResponse>(`/quotations/${id}/convert`),

  markAsSent: (id: number) => api.patch(`/quotations/${id}/mark-sent`),

  uploadImage: (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    // Do NOT set Content-Type manually — axios will set it with the correct boundary
    return api.post('/quotations/upload-image', formData);
  },
};
